import { useNavigate } from "react-router-dom";

export default function CTA() {
  const navigate = useNavigate();

  return (
    <section className="py-20 md:py-28 bg-accent-500 relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute top-0 right-0 w-96 h-96 rounded-full bg-accent-600/30 -translate-y-1/2 translate-x-1/4"></div>
        <div className="absolute bottom-0 left-0 w-80 h-80 rounded-full bg-accent-400/20 translate-y-1/3 -translate-x-1/4"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-extrabold text-background-50 mb-4">
          Ready to Transform Your Restaurant?
        </h2>
        <p className="text-sm md:text-base text-background-100 mb-8 max-w-xl mx-auto">
          Join 2,500+ restaurants already using EzyDinePro. Start your 7-day
          free trial today — no credit card, no commitment.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => navigate("/login")}
            className="w-full sm:w-auto px-8 py-3.5 text-sm md:text-base font-semibold text-accent-600 bg-background-50 hover:bg-background-100 rounded-md transition-colors whitespace-nowrap cursor-pointer"
          >
            Start Free Trial Now
            <i className="ri-arrow-right-line ml-2"></i>
          </button>
          <a
            href="#pricing"
            onClick={(e) => {
              e.preventDefault();
              const el = document.querySelector("#pricing");
              if (el) el.scrollIntoView({ behavior: "smooth" });
            }}
            className="w-full sm:w-auto px-8 py-3.5 text-sm md:text-base font-semibold text-background-50 border-2 border-background-50/30 hover:bg-background-50/10 rounded-md transition-colors whitespace-nowrap cursor-pointer"
          >
            View Pricing
          </a>
        </div>
      </div>
    </section>
  );
}